// Best-effort error bridge for Lovable's runtime capture. If the platform
// injects a global handler, forward to it; otherwise log to console.

type Meta = Record<string, unknown>;

interface LovableWindow extends Window {
  __LOVABLE_REPORT_ERROR__?: (error: unknown, meta?: Meta) => void;
}

export function reportLovableError(error: unknown, meta?: Meta): void {
  if (typeof window === "undefined") {
    console.error("[lovable-error]", error, meta);
    return;
  }
  const w = window as LovableWindow;
  if (typeof w.__LOVABLE_REPORT_ERROR__ === "function") {
    try {
      w.__LOVABLE_REPORT_ERROR__(error, meta);
      return;
    } catch {
      /* fall through */
    }
  }
  console.error("[lovable-error]", error, meta);
}
